<template>
	<page class="page flex justify-center align-center">
		<v-row>
			<v-col>
				<close-app-logo color="dark" />
			</v-col>
		</v-row>

		<div class="flex mt-10">
			<div class="white--text justify-center align-center text-center">
				<h3 class="white--text">
					בקשת אישור
				</h3>
				<p class="text--white">
					<strong>{{ info.clientName }}</strong> מבקש הרשאה לגשת לחשבונך.
				</p>
				<v-row class="flex flex-row justify-center align-center text-center">
					<form
						ref="form"
						method="DELETE"
						action="/oauth/authorize"
					>
						<input
							type="hidden"
							name="_token"
							:value="csrf"
						>
						<input
							v-model="form.state"
							type="hidden"
							name="state"
						>
						<input
							v-model="form.authToken"
							type="hidden"
							name="access_token"
						>
						<input
							v-model="form.clientId"
							type="hidden"
							name="client_id"
						>
						<v-btn
							color="#d13120"
							type="submit"
						>
							Cancel
						</v-btn>
					</form>
					<form
						ref="form"
						method="POST"
						action="/oauth/authorize"
					>
						<input
							type="hidden"
							name="_token"
							:value="csrf"
						>
						<input
							v-model="form.state"
							type="hidden"
							name="state"
						>
						<input
							v-model="form.authToken"
							type="hidden"
							name="access_token"
						>
						<input
							v-model="form.clientId"
							type="hidden"
							name="client_id"
						>
						<v-btn
							color="#4595cc"
							type="submit"
						>
							Authorize
						</v-btn>
					</form>
				</v-row>
			</div>
		</div>
	</page>
</template>

<script>
import CloseAppLogo from "@/components/CloseAppLogo";

export default {
	name: "Authorize",
	components: { CloseAppLogo },
	data () {
		return {
			form: {},
		};
	},
	computed: {
		info () {
			return window.authrizeData;
		},
		csrf () {
			return document.querySelector("meta[name=csrf-token]").getAttribute("content");
		},
	},
	mounted () {
		["state", "authToken", "clientId"].forEach(keys => {
			this.$set(this.form, keys, this.info[keys]);
		});
	},
	methods: {},
};
</script>

<style lang="scss" scoped>
    @import "./../../sass/generic";

    .page {
        width: 90%;
        margin: auto;
        background-color: $background;

        @include responsive($mobile) {
            max-width: $mobile !important;
            max-height: $mobile-height;
        }

        .project-name {
            &--col {
                padding: 0;

                div {
                    height: 40px;
                    width: 220px;
                    background: #4595cc 0 0 no-repeat padding-box;
                    border-radius: 0 0 20px 20px;
                    opacity: 1;
                }
            }
        }

    }
</style>
